<div class="contacts-table-option">
  <div class="contact-table-top-panel">
    <div class="contact-table-top-panel-left">
      <div class="date-section-line">
        <span>{{dateDateView}}</span>
        <i #openCalendar class="fas fa-calendar-alt open-calendar" (click)="openPicker()"></i>
      </div>
      <div class="button-tag-wrapper" *ngxPermissionsOnly="'TAGS_PERMISSION'">
        <button
          class="tag-selector contact-table-top-panel-button"
          title="{{'CONTACTS_LIST.TAG_SELECTED' | translate }}"
          [class.disabled]="!this.selected.length"
          (click)="toggleOpenTagEditor()">
          <i class="fas fa-tag"></i>
        </button>
        <div class="tag-editor-wrapper" [class.opened]="tagEditorOpened">
          <cc-tag></cc-tag>
        </div>
      </div>
      <button [class.disabled]="!this.selected.length"
              class="delete-selected contact-table-top-panel-button"
              title="{{'CONTACTS_LIST.DELETE_SELECTED' | translate }}"
              (click)="confirmToDelete()">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
    <div class="contact-table-top-panel-right">
      <div class="total-found-info">
        <span class="total-found-info-label" translate="CONTACTS_LIST.FOUND"></span>
        <span class="total-found-info-value"> {{total}} </span>
        <span class="total-found-info-value">
          {{(total === 1) ? 'CONTACT' : 'CONTACTS_TITLE' | translate }}
          </span>
      </div>
      <form action="" class="pagination-selector">
        <div class="pagination-selector-label" translate>SHOW</div>
        <mat-form-field>
          <mat-select [(ngModel)]="page.pagination.limit" name="pagination"
                      (selectionChange)="changePagination($event)">
            <mat-option *ngFor="let pag of paginationOptions" [value]="pag">
              {{pag}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <button
        class="filters-button contact-table-top-panel-button"
        (click)="addFilter()"
        color="primary-full">
          <span>
            <i class="fas fa-filter"></i>
          </span>
        <div class="filter-counter"
             *ngIf="tempEditedFiltersList && tempEditedFiltersList.length">
          <span>{{tempEditedFiltersList.length}}</span>
        </div>
      </button>
    </div>
    <div class="contacts-table-top-panel-mass-actioner"
         [class.expanded]="selected.length"
         [@openClose]="selected.length ? 'open' : 'closed'">
      <div *ngIf="!isMassiveAction">
        {{(selected.length === 1 ? 'CONTACTS_LIST.ONE_ACTION_SELECTED_ON_PAGE' : 'CONTACTS_LIST.MASSIVE_ACTION_SELECTED_ON_PAGE') | translate: {selected: selected.length} }}
      </div>
      <div *ngIf="isMassiveAction">{{'CONTACTS_LIST.MASSIVE_ACTION_SELECTED_TOTAL' | translate: {
        totalSelected: total - excludedContacts.length, total: total} }}</div>
      <div class="info-label" (click)="toggleMassiveOptionAction()"
           *ngIf="!isMassiveAction">{{'CONTACTS_LIST.MASSIVE_ACTION_SELECT' | translate: {total: total} }}</div>
      <div class="warning-label" (click)="toggleMassiveOptionAction()" *ngIf="isMassiveAction">
        {{'CONTACTS_LIST.MASSIVE_ACTION_UNSELECT_ALL' | translate }}
      </div>
    </div>

    <div class="contacts-table-top-panel-result-informer"
         [class.expanded]="shouldDisplayEventResultInfo()"
         [@openClose]="shouldDisplayEventResultInfo() ? 'open' : 'closed'">
      <div class="info-label" >{{'CONTACTS_LIST.SEARCH_RESULTS_INFO' | translate}}</div>
    </div>

  </div>

  <ngx-datatable #myTable
                 (scroll)="onScroll($event)"
                 class="material contact-table"
                 [rows]="rows"
                 [columns]="columns"
                 [columnMode]="'force'"
                 [headerHeight]="48"
                 [summaryRow]="false"
                 [summaryPosition]="'bottom'"
                 [footerHeight]="total > filterParams.pagination.limit ? 40 : 0"
                 [rowHeight]="60"
                 [scrollbarH]="true"
                 [reorderable]="reorderable"
                 [swapColumns]="swapColumns"
                 [selected]="selected"
                 [selectionType]="'checkbox'"
                 [selectAllRowsOnPage]="false"
                 [externalSorting]="true"
                 (sort)="onSort($event)"
                 (select)="onSelect($event)"
                 [rowIdentity]="getRowIdentity"
                 [externalPaging]="true"
                 [limit]="filterParams.pagination.limit"
                 (page)="setPage($event)"
                 [count]="total"
                 [offset]="tableOffset"
                 [loadingIndicator]="loadingIndicator"
                 [messages]="messages"
                 (resize)="resizeColumns()"
                 (activate)="toggleExpandRow($event)"
  >
    <!-- Row Detail Template -->
    <ngx-datatable-row-detail [rowHeight]="auto" #myDetailRow (toggle)="onDetailToggle($event)">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
        <!-- Inside Table Template -->
        <ngx-datatable
          class="fullscreen detail-inner-row"
          [rows]="row.events"
          [loadingIndicator]="loadingIndicator"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="1"
          [summaryRow]="false"
          [footerHeight]="0"
          [rowHeight]="50"
          [reorderable]="reorderable"
          [selectAllRowsOnPage]="false"
          (activate)="onActivate($event)"
          (select)="onSelect($event)">

          <!-- Inside Column Templates -->
          <!-- first one-->
          <ngx-datatable-column
            [width]="150"
            [resizeable]="false"
            [sortable]="false"
            [draggable]="false"
            [canAutoResize]="true"
            [checkboxable]="false"
            [frozenLeft]="true">

            <!-- Inside Row Templates -->
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a [routerLink]="'/contact-details/' + row.recordId + '/' + row.event_id"
                 [title]="'CONTACTS_LIST.DETAILS' | translate"
                 class="event-details-link-wrapper"
                 (click)="rememberPaginationOffset()"
                 (ccDomChange)="onDomChange($event)">
                <i class="event-details material-icons perm-contact-calendar"
                   [class.visible]="activeEvent === row.event_id">event_note</i>
              </a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="NATIVE_EVENT_TYPE"
            [width]="100"
            [resizeable]="false"
            [sortable]="false"
            [draggable]="false"
            [canAutoResize]="false"
            [frozenLeft]="true">

            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
              <span
                *ngIf="row['NATIVE_EVENT_TYPE'] !== 'FailedContactEvent'"
                [title]="getEventTypeLabel(row['NATIVE_EVENT_TYPE']) | translate"
              >
                  {{ getEventTypeLabel(row['NATIVE_EVENT_TYPE']) | translate }}
              </span>

              <span *ngIf="row['NATIVE_EVENT_TYPE'] === 'FailedContactEvent'"
                    [title]="'SYSTEM_EVENTS.' + row['NATIVE_EVENT_STATUS_INFO'] | translate"
              >
                  {{ 'SYSTEM_EVENTS.' + row['NATIVE_EVENT_STATUS_INFO'] | translate}}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- the rest of generic columns-->
          <ngx-datatable-column
            *ngFor="let insideCol of columns"
            [prop]="insideCol.key"
            [name]="insideCol.translation"
            [width]="175"
            [frozenLeft]="insideCol.frozenLeft"
            [sortable]="insideCol.key.startsWith('NATIVE') && insideCol.key !== 'NATIVE_CLIENT_PHONE_NUMBER' "
            [headerCheckboxable]="true"
            [checkboxable]="true">
            <ng-template let-row="row"
                         *ngIf="insideCol.key === 'NATIVE_CLIENT_PHONE_NUMBER' || insideCol.key === 'NATIVE_AGENT_PHONE_NUMBER'"
                         ngx-datatable-cell-template>
              <span *ngIf="row[insideCol.key] && row[insideCol.key][0] && row[insideCol.key][0].msisdn">
                <span *ngIf="insideCol.key === 'NATIVE_CLIENT_PHONE_NUMBER'"
                      [title]="'CONTACTS_LIST.DETAILS' | translate"
                      class="light-viewed">{{row[insideCol.key][0].msisdn | phoneNumber}}</span>
              </span>
              <span *ngIf="row[insideCol.key] && row[insideCol.key][0] && row[insideCol.key][0].msisdn">
                <span *ngIf="insideCol.key === 'NATIVE_AGENT_PHONE_NUMBER'"
                      [title]="row[insideCol.key][0].msisdn">{{row[insideCol.key][0].msisdn | phoneNumber}}</span>
              </span>
            </ng-template>
            <ng-template let-row="row" *ngIf="insideCol.key === 'NATIVE_EVENT_DATE'" ngx-datatable-cell-template>
              <span [title]="getDateFormated(row[insideCol.key])">{{getDateFormated(row[insideCol.key])}}</span>
            </ng-template>
            <ng-template let-row="row" *ngIf="insideCol.key === 'NATIVE_EVENT_TYPE'" ngx-datatable-cell-template>
              <span
                [title]="getEventTypeLabel(row[insideCol.key]) | translate">{{getEventTypeLabel(row[insideCol.key]) | translate}}</span>
            </ng-template>
            <ng-template let-row="row" *ngIf="insideCol.key === 'NATIVE_CALL_LENGTH'" ngx-datatable-cell-template>
              <span [title]="getCallLengthLabel(row[insideCol.key])">{{getCallLengthLabel(row[insideCol.key])}}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Last HEADER with buttons -->
          <!--          <ngx-datatable-column name="" >-->
          <!--            <ng-template let-column="column" ngx-datatable-header-template>-->
          <!--              <a href="#" class="table-header-button btn btn-default" (click)="buttonClick($event)"></a>-->
          <!--                <i class="material-icons add-layer-icon">add</i><span>{{'ADD' | translate}}</span>-->
          <!--            </ng-template>-->
          <!--          </ngx-datatable-column>-->
          <!-- end of Last HEADER with buttons -->
        </ngx-datatable>
      </ng-template>
    </ngx-datatable-row-detail>

    <!-- First HEADER column with buttons -->
    <ngx-datatable-column name=""
                          [width]="60"
                          [resizeable]="true"
                          [sortable]="false"
                          [draggable]="false"
                          [headerCheckboxable]="true"
                          [checkboxable]="true"
                          [canAutoResize]="false"
                          [frozenLeft]="true">
      <ng-template let-column="column" ngx-datatable-header-template>
      </ng-template>
    </ngx-datatable-column>
    <!-- end of first HEADER with buttons -->

    <!-- Column Templates -->
    <!-- first one -->
    <ngx-datatable-column
      name=""
      [width]="10"
      [resizeable]="false"
      [sortable]="false"
      [draggable]="false"
      [canAutoResize]="false"
      [frozenLeft]="true">

      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
        <a
          *ngIf="row.events_count"
          class="events-counter"
          [class.expanded]="isRowExpanded(row)"
          href="#"
          title="Expand/Collapse Row">{{row.events_count}}</a>
        <span *ngIf="!row.events_count" class="events-counter-space"></span>
      </ng-template>
    </ngx-datatable-column>

    <!-- the rest of generic columns-->
    <ngx-datatable-column
      *ngFor="let col of columns"
      [prop]="col.key"
      [name]="col.name | translate"
      [width]="170"
      [frozenLeft]="col.frozenLeft"
      [sortable]="col.key.startsWith('NATIVE') && col.key !== 'NATIVE_CLIENT_PHONE_NUMBER' ">
      <ng-template let-row="row"
                   *ngIf="col.key === 'NATIVE_CLIENT_PHONE_NUMBER'"
                   ngx-datatable-cell-template
      >
        <span *ngIf="row[col.key][0] && row[col.key][0].isoCountry" class="flag-icon m-r-xs"
              [ngClass]="'flag-icon-'+ row[col.key][0].isoCountry"></span>
        <span *ngIf="row[col.key][0] && row[col.key][0].msisdn">
          <span *ngIf="col.key === 'NATIVE_CLIENT_PHONE_NUMBER'"
                [title]="row[col.key][0].msisdn"
                class="clickable-number">{{row[col.key][0].msisdn | phoneNumber}}</span>
        </span>
        <cc-call-icon *ngIf="row[col.key] && row[col.key].length && row[col.key][0].isoCountry"
          [number]="row[col.key][0].msisdn"></cc-call-icon>
      </ng-template>

      <ng-template let-row="row"
                   *ngIf="col.key === 'NATIVE_AGENT'"
                   ngx-datatable-cell-template>
        <div class="contact-table-details-cell">
          <cc-flag-label-item
            [label]="row[col.key].agentLogin"
            [number]="row[col.key].agentNumber && row[col.key].agentNumber.msisdn ? row[col.key].agentNumber.msisdn : ''"
            [numberLabel]="row[col.key].agentNumber && row[col.key].agentNumber.label"
            [empty]="'UNASSIGNED'">
          </cc-flag-label-item>
        </div>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_EVENT_DATE'" ngx-datatable-cell-template>
        <span [title]="getDateFormated(row[col.key])">{{getDateFormated(row[col.key])}}</span>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_EVENT_TYPE'" ngx-datatable-cell-template>
        <span
          [title]="getEventTypeLabel(row[col.key]) | translate">{{getEventTypeLabel(row[col.key]) | translate}}</span>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_CALL_LENGTH'" ngx-datatable-cell-template>
        <span [title]="getCallLengthLabel(row[col.key])">{{getCallLengthLabel(row[col.key])}}</span>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_DETAILS'" ngx-datatable-cell-template>
        <div class="contact-table-details-cell">
          <div class="details-name" [title]="row[col.key].name">{{row[col.key].name}}</div>
          <div class="details-email" *ngIf="row[col.key].email"
               [title]="row[col.key].email">{{row[col.key].email}}</div>
        </div>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_TAGS'" class="tag-row" ngx-datatable-cell-template>

        <div class="table-cell-tag-wrapper">
          <div class="tag-editor-opener table-cell-tag"
               *ngxPermissionsOnly="'TAGS_PERMISSION'"
               [title]="'CONTACTS_LIST.EDIT_TAGS' | translate"
               (click)="openEditorTag(row, $event)">
            <i class="material-icons tag-editor-opener-icon">
              more_horiz
            </i>
          </div>
          <div *ngFor="let tag of row[col.key]" class="table-cell-tag">
            {{tag}}
          </div>
        </div>

      </ng-template>
    </ngx-datatable-column>

    <!-- last HEADER column with buttons -->
    <!--  <ngx-datatable-column name="" [width]="160" [frozenRight]="true">-->
    <!--    <ng-template let-column="column" ngx-datatable-header-template>-->
    <!--      <a href="#" (click)="buttonClick($event)" class="layer-button-add temporary-hidden">-->
    <!--        <i class="material-icons add-layer-icon">add</i>-->
    <!--        <span>{{'CONTACTS_LIST.ADD_LAYER' | translate}}</span>-->
    <!--      </a>-->
    <!--      <a href="#"  class="table-header-button eye-icon-wrapper temporary-hidden" (click)="buttonClick($event)">-->
    <!--        <i class="material-icons add-layer-icon">remove_red_eye</i>-->
    <!--      </a>-->
    <!--    </ng-template>-->
    <!--  </ngx-datatable-column>-->
    <!-- end of HEADER with buttons -->

  </ngx-datatable>
</div>

